/**
 * trainingMode.ts — トレーニングモードの判定（2026-08-24）
 *
 * `/daylist/training` を開いている間だけ true になる。
 * この間、フロントは **本番バックエンドに一切書き込まない**:
 *
 *   - 読み取り(vehicles / reservations) … trainingBackend のダミーデータを返す
 *   - 書き込み(車両更新 / 予約保存 など) … trainingBackend のメモリ上だけ更新
 *   - 上記以外の非 GET リクエスト     … dispatchClient.apiFetch が握り潰して失敗させる
 *
 * ステータスマスタ・スタッフ一覧などの GET は本物を使う。ラベルや配色が
 * 本番と同じでないと練習にならないため。
 *
 * 判定を pathname に置いているのは、モジュール読み込み順やコンテキストに
 * 依存せず、API 層のどこからでも同期的に参照できるようにするため。
 */
export const TRAINING_PATH = '/daylist/training';

export const isTrainingMode = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.pathname.startsWith(TRAINING_PATH);
};
